import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Spacer from '../spacer/Spacer';

const sizes = [16, 18, 24, 32, 48];

const Svg = ({
    ariaLabel,
    className,
    size,
    image,
    style,
    ...otherProps
}) => {
    let svgData = null;

    if (typeof image === 'object' && !!image.data) {
        const properties = {
            xmlns: 'http://www.w3.org/2000/svg',
            className: 'svg'
        };

        if (image.viewBox) {
            properties.viewBox = image.viewBox;
        }

        if (image.preserveAspectRatio) {
            properties.preserveAspectRatio = image.preserveAspectRatio;
        }

        svgData = <svg {...properties}>{image.data}</svg>;
    }

    const classes = cx('svg__wrapper', size && `svg--${size}`, className);

    return (
        <Spacer
            as="span"
            aria-label={ariaLabel}
            className={classes}
            style={style}
            aria-hidden={true}
            {...otherProps}
        >
            {svgData}
        </Spacer>
    );
};

Svg.propTypes = {
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.oneOf(sizes),
    image: PropTypes.obj,
    style: PropTypes.obj
};

export default Svg;
